<form [formGroup]="emailForm" (ngSubmit)="onSubmit()">
  <mat-form-field class="w-full mb-5" appearance="outline">
    <mat-label>Correo Electrónico</mat-label>
    <input matInput formControlName="email" type="email" placeholder="ejemplo@sitrack.mx" [disabled]="disabled" required />
    @if (emailForm.get('email')?.invalid && emailForm.get('email')?.touched) {
      <mat-error>
        Por favor, ingrese un correo electrónico válido.
      </mat-error>
    }
  </mat-form-field>

  <button matButton="filled" 
          color="primary" 
          type="submit" 
          [disabled]="emailForm.invalid || disabled" 
          class="w-full mb-4 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 sm:py-3 px-4 rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base">
    Solicitar OTP
  </button>

  <div class="mt-6 sm:mt-8 text-center">
    <p class="text-xs sm:text-sm text-slate-600 mb-3">
      ¿Es usted un proveedor de <strong class="text-slate-800">Arcelor Mittal</strong> y no tiene una cuenta?
    </p>
    <button matButton="outlined" 
            type="button" 
            (click)="onProviderRegistrationClick()" 
            [disabled]="disabled"
            class="w-full text-xs sm:text-sm text-slate-700 border border-slate-300 bg-white hover:bg-slate-50 py-2 sm:py-3 px-3 sm:px-4 rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed leading-relaxed">
      Solicitar acceso
    </button>
  </div>

</form>